import { render } from "./NewsItemTable.vue?vue&type=template&id=d43bd276"
import script from "./NewsItemTable.vue?vue&type=script&lang=js"
export * from "./NewsItemTable.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__